export function calcAutoFontSize(minValue: number = 14): number {
  return Math.max(Math.trunc(1.5 * Math.min(document.documentElement.clientHeight, document.documentElement.clientWidth) / 100), minValue);
}
